import './bootstrap';
import '../sass/app.scss'
import LoginPage from "./components/LoginPage.vue";
import TenantPage from "./components/pages/TenantPage.vue";
import TopNav from "./components/TopNav.vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Antdv from "ant-design-vue";
import {createApp} from 'vue';
import Router from './router'
import store from "./store";
import mitt from 'mitt';
import vClickOutside from "click-outside-vue3";
import {defineRule} from 'vee-validate';
import AllRules from '@vee-validate/rules';
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const emitter = mitt();
const app = createApp({
    components: {
        LoginPage,
        TenantPage,
        TopNav,
    }
})

app.config.globalProperties.emitter = emitter;
app.use(store)
app.use(Router)
app.use(Antdv)
app.use(Toast)
app.use(vClickOutside)
app.use(LoadingPlugin);
Object.keys(AllRules).forEach(rule => {
    defineRule(rule, AllRules[rule]);
});
app.mount('#app')
app.component('quill-editor', QuillEditor)
